// The public channels a Slack connection is chosen from, before it is saved (#604).
//
// Read off `routes/integrations.py` (`list_slack_channels`) and `integrations/listing.py`.
// The bot token is in the body because there is nowhere else for one that has not been
// saved; it is used for the one read and never comes back. An answer's first three keys
// are a check's (`CheckRow`), so a list Slack would not give is read through the words a
// failed check is (`console/connectionHealth.ts`).
//
// **One page, or none.** Where Slack has a page the list did not read, the answer is a
// refusal with `more` set and no channels, never a list that silently lacks the one a
// person is looking for; the flow then asks for the channel's ID.

import type { Api } from "./http";
import type { SlackCredential } from "./integrations";

export const SLACK_CHANNELS_PATH = "/api/v1/integration-setup/slack/channels";

export interface SlackChannel {
  id: string;
  name: string;
  /** The app is in the channel, and so may post to it. */
  is_member: boolean;
}

export interface ListedChannels {
  status: "passed" | "failed";
  last_status: number | null;
  last_detail: string;
  channels: SlackChannel[];
  /** Slack has channels on a page this list did not read: refused, not cut. */
  more: boolean;
}

/**
 * The token a flow's sign-in step was given, a saved connection being edited (#817), or the
 * workspace's installation Add to Slack made (#936, #937): the server opens the last two's own.
 */
export type SlackAsking = { credential: SlackCredential } | { connection_id: string } | { installation_id: string };

export const listSlackChannels = (api: Api, asking: SlackAsking): Promise<ListedChannels> =>
  api.post<ListedChannels>(SLACK_CHANNELS_PATH, asking);

/** Reads the channel list, for a flow that holds no `Api` of its own. */
export interface SlackLister {
  channels(asking: SlackAsking): Promise<ListedChannels>;
}
